class PWSJO_Timetable {
    constructor () {
        if ($('.timetable-list-wrapper').length) {
            this.initState();
            this.loadConfig();
            this.setupUI();
            this.initEvents();
            this.showHoursByLang();
        }
    }

    initState () {
        this.state = {
            orderBy: 'person',
            orderDir: 'ASC'
        };

        this.UI = {
            headCellsWrapper: $('.timetable-table-heading'),
            lists: $('.timetable-items')
        };
    }

    loadConfig () {
        if (localStorage.getItem('pwsjo-timetable-order-by')) {
            let column = localStorage.getItem('pwsjo-timetable-order-by');

            if (['person'].indexOf(column) > -1) {
                this.state.orderBy = column;
            }
        }

        if (localStorage.getItem('pwsjo-timetable-order-dir')) {
            let direction = localStorage.getItem('pwsjo-timetable-order-dir');

            if (['ASC', 'DESC'].indexOf(direction) > -1) {
                this.state.orderDir = direction;
            }
        }
    }

    setupUI () {
        this.UI.headCellsWrapper.find('div[data-orderby="' + this.state.orderBy + '"]').addClass('is-active');
        
        if (this.state.orderDir === 'ASC') {
            this.UI.headCellsWrapper.find('div[data-orderby="' + this.state.orderBy + '"]').addClass('is-asc');
        } else {
            this.UI.headCellsWrapper.find('div[data-orderby="' + this.state.orderBy + '"]').addClass('is-desc');
        }

        this.sortItems(this.state.orderBy, this.state.orderDir);
    }

    initEvents () {
        this.initHeadCells();
    }

    initHeadCells () {
        let cells = this.UI.headCellsWrapper.find('div[data-orderby]');

        cells.each((i, cell) => {
            $(cell).on('click', e => {
                e.preventDefault();

                if ($(cell).hasClass('is-active')) {
                    if ($(cell).hasClass('is-asc')) {
                        $(cell).removeClass('is-asc').addClass('is-desc');
                        this.sortItems($(cell).attr('data-orderby'), 'DESC');
                    } else {
                        $(cell).removeClass('is-desc').addClass('is-asc');
                        this.sortItems($(cell).attr('data-orderby'), 'ASC');
                    }
                } else {
                    cells.removeClass('is-active').removeClass('is-asc').removeClass('is-desc');
                    $(cell).addClass('is-active').addClass('is-asc');
                    this.sortItems($(cell).attr('data-orderby'), 'ASC');
                }
            });
        });
    }

    saveState (orderBy, orderDir) {
        this.state.orderBy = orderBy;
        this.state.orderDir = orderDir;
        localStorage.setItem('pwsjo-timetable-order-by', orderBy);
        localStorage.setItem('pwsjo-timetable-order-dir', orderDir);
    }

    sortItems (orderBy, orderDir) {
        this.saveState(orderBy, orderDir);
        
        this.UI.lists.each((i, list) => {
            $(list).find('.timetable-item').sort((itemA, itemB) => {
                if (this.state.orderDir === 'ASC') {
                    return $(itemA).attr('data-' + this.state.orderBy).localeCompare($(itemB).attr('data-' + this.state.orderBy));
                } else {
                    return $(itemB).attr('data-' + this.state.orderBy).localeCompare($(itemA).attr('data-' + this.state.orderBy));
                }
            }).appendTo($(list));
        });
    }

    showHoursByLang () {
        this.timetable = $('.timetable');
        this.selectLang = this.timetable.find('.select-language');

        if (this.timetable.length) {
            this.selectLang.change(function(){
                $(this).find("option:selected").each(function() {
                    var optionValue = $(this).attr("value");

                    if(optionValue){
                        $(".timetable-items").not('[data-lang="' + optionValue + '"]').removeClass('is-active');
                        $(".timetable-items[data-lang='" + optionValue + "']").addClass('is-active');
                    } else{
                        $(".timetable-items").removeClass('is-active');
                    }
                });
            }).change();
        }
    }
}